<section id="accidents-records">

  <div class="flex flex-col-reverse sm:flex-row gap-2 mb-8">
    <div class="flex-grow mb-2">
      <div>
        <nz-collapse>
          <nz-collapse-panel [nzHeader]="'Advanced Search'">
            <div
              class="flex flex-col lg:flex-row sm:justify-between 2xl:items-center gap-4">

              <div class="flex flex-col min-[1100px]:flex-row min-[1100px]:items-end">
                <!--            <div class="flex flex-col sm:flex-row">-->
                <nz-form-item class="flex flex-col xl:flex-row m-0">
                  <nz-form-label class="text-start">Filter By Date</nz-form-label>
                  <div class="flex flex-row items-center">
                    <nz-range-picker
                      class="w-full 2xl:w-auto"
                      [(ngModel)]="dateFilter"
                      [nzAllowClear]=false
                      nzFormat="yyyy/MM/dd"
                      (ngModelChange)="searchDate()"
                    ></nz-range-picker>
                    <nz-divider class="hidden min-[1100px]:block" [nzType]="'vertical'"></nz-divider>
                  </div>

                </nz-form-item>
                <!--            </div>-->


                <!--            <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">-->
                <!--              <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">-->
                <!--            <div class="flex flex-row items-center w-full">-->
                <!--              <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>-->
                <nz-form-item class="m-0 mt-2 min-[1100px]:m-0">
                  <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">
                    <input type="text" (keydown.enter)="search()" [(ngModel)]="searchText" nz-input
                           placeholder="Search Accidents"/>
                  </nz-input-group>
                  <ng-template #suffixIconSearchButton>
                    <button nz-button nzType="primary" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]"
                            (click)="search()">
                      <span nz-icon nzType="search"></span>
                    </button>
                  </ng-template>
                </nz-form-item>
                <!--            </div>-->
                <!---->


                <!--              <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">-->
                <!--                <input type="text" [(ngModel)]="placeFilter" nz-input placeholder="Search Accident Place"/>-->
                <!--              </nz-input-group>-->
                <!--              <ng-template #suffixIconSearchButton>-->
                <!--                <button nz-button nzBlock class="outline-button" (click)="search()">-->
                <!--                  <span nz-icon nzType="search"></span>-->
                <!--                </button>-->
                <!--              </ng-template>-->
                <!--              </div>-->
                <!--            </div>-->

              </div>

              <div>
                <button nz-button nzBlock class="outline-button btn_reset_search" (click)="resetSearch()">
                  Reset All
                </button>
              </div>
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </div>
    <button *appHasAnyPrivilege="'ACCIDENT_RECORDS_CREATE'" nz-button nzType="primary"
            routerLink="/admin/fleets/{{fleetData._id}}/accidents/add-edit">
      New Accident Record
    </button>
  </div>

  <div>
    <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
      <div class="table-obj">
        <nz-table #basicTable [nzData]="accidentsData" [nzShowSizeChanger]="pageSize.length > 5"
                  [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
                  [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
                  (nzQueryParams)="onTableParamsChange($event)" nzTableLayout="fixed" [nzScroll]="{ x: 'auto', y: '550px' }"
                  nzOuterBordered class="table-wSpace-nowrap">
          <thead>
          <tr>
            <th>Accident No.</th>
            <th>Accident Date and Time</th>
            <th>Filled by</th>
            <th>Booking ID</th>
            <th>Reason</th>
            <th>Driver Name</th>
            <th>Place</th>
            <th>Insurance follow up status</th>
            <th>
              <div class="flex">
                <span>Created Date</span>
                <span *ngIf="sortOrder === -1" nz-icon nzType="up" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
                <span *ngIf="sortOrder === 1" nz-icon nzType="down" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
              </div>
            </th>
            <th *appHasAnyPrivilege="'ACCIDENT_RECORDS_SINGLE_VIEW,ACCIDENT_RECORDS_DELETE'">Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of basicTable.data">
            <td style="white-space: nowrap; min-width: 200px">
              <a *appHasAnyPrivilege="'ACCIDENT_RECORDS_SINGLE_VIEW'"
                 (click)="viewAccidentRecord(data._id)">{{ data?.refNo ? data?.refNo : '-' }}</a>
              <span *ngIf="!hasPermission('ACCIDENT_RECORDS_SINGLE_VIEW')">{{ data?.refNo ? data?.refNo : '-' }}</span>
            </td>
            <td style="white-space: nowrap; min-width: 200px">{{ data?.accidentDetails?.accidentDateAndTime | date: "dd-MM-y | hh:mm aa" }}</td>
            <td style="white-space: nowrap; min-width: 200px">
              {{
                data?.notifiedOrDetectedUserName
              }}
            </td>
            <td style="white-space: nowrap; min-width: 200px">{{ data?.relatedBookingRefNo ? data?.relatedBookingRefNo : '-' }}</td>
            <td style="white-space: nowrap; min-width: 200px">{{ data?.reason ? data?.reason : '-' }}</td>
            <td style="white-space: nowrap; min-width: 200px">
              {{ data?.driverDetails?.driverName }}
            </td>
            <td style="white-space: nowrap; min-width: 200px">{{ data?.accidentDetails?.placeOfTheAccident }}
            </td>
            <td style="white-space: nowrap; min-width: 200px">
              <nz-tag
                *ngIf="data?.accidentDetails?.needToNotifyTheInsurance && (data.accidentDetails?.insuranceNotified === 'ON_DEPARTURE' || data.accidentDetails?.insuranceNotified === 'ON_SITE')"
                [nzColor]="'#3ab200'" class="rounded-full hover:cursor-pointer"
              >Informed
              </nz-tag>
              <nz-tag
                *ngIf="data.accidentDetails?.needToNotifyTheInsurance && (!(data.accidentDetails?.insuranceNotified === 'ON_DEPARTURE') && !(data.accidentDetails?.insuranceNotified === 'ON_SITE'))"
                [nzColor]="'#F3454C'" class="rounded-full hover:cursor-pointer"
              >Not informed
              </nz-tag>
            </td>
            <td style="white-space: nowrap; min-width: 200px">{{ data.createdAt | date: "dd-MM-y" }}</td>
            <td *appHasAnyPrivilege="'ACCIDENT_RECORDS_SINGLE_VIEW,ACCIDENT_RECORDS_DELETE'">
              <div class="flex gap-1">
                <button *appHasAnyPrivilege="'ACCIDENT_RECORDS_SINGLE_VIEW'" (click)="viewAccidentRecord(data._id)"
                        class="outline-button mr-3" nz-button nzType="default">
                  View
                </button>
                <button *appHasAnyPrivilege="'ACCIDENT_RECORDS_DELETE'" class="outline-button more-dropdown" nz-button
                        nz-dropdown
                        [nzDropdownMenu]="menu"
                        nzPlacement="bottomCenter">
                  <span nz-icon nzType="more" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li *appHasAnyPrivilege="'ACCIDENT_RECORDS_DELETE'" nz-menu-item nz-popconfirm nz-button nzDanger
                        nzPopconfirmTitle="Are you sure you want to delete this accident record?"
                        (nzOnConfirm)="softDeleteConfirm(data._id)" (nzOnCancel)="cancel()">
                      Delete
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </div>
            </td>
          </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-table-skeleton-template [columnData]="skeletonTableColumns"
                                   [showAdvanceSearch]="false"></app-table-skeleton-template>
    </div>
  </div>
</section>
